// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__T0H8v","noInteraction":"EventWrapper_noInteraction__1rhAw"};